import { render } from "./IndexPrincipal.vue?vue&type=template&id=235a35a5&scoped=true"
import script from "./IndexPrincipal.vue?vue&type=script&lang=js"
export * from "./IndexPrincipal.vue?vue&type=script&lang=js"

import "./IndexPrincipal.vue?vue&type=style&index=0&id=235a35a5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235a35a5"]])

export default __exports__